<script setup lang="ts">
import { computed } from 'vue'
import { SectionSettings } from './types'
import { getColorById } from './utils'

interface Props {
  settings?: SectionSettings
}

const props = withDefaults(defineProps<Props>(), {
  settings: () =>
    ({
      alignment: 'left',
      show_title: true,
      design_settings: {
        colors: [],
        fonts: [],
      },
    }) as SectionSettings,
})

const fontFamily = computed(() => {
  return props.settings.design_settings?.fonts?.join(', ')
})

const backgroundColor = computed(() =>
  getColorById(props.settings.design_settings?.colors, 'background_color'),
)
const textColor = computed(() => getColorById(props.settings.design_settings?.colors, 'text_color'))
const alignment = computed(() => props.settings.alignment)

const sectionStyles = computed(() => ({
  backgroundColor: backgroundColor.value,
  color: textColor.value,
  fontFamily: fontFamily.value,
}))
</script>

<template>
  <div class="customer-page-section rounded" :style="sectionStyles">
    <h2 v-if="settings.show_title && settings.title" class="heading">
      {{ settings.title }}
    </h2>
    <slot></slot>
  </div>
</template>

<style scoped lang="sass">
.customer-page-section
  text-align: v-bind(alignment)
  padding: 2.5rem
.heading
  font-size: 1.5rem
</style>
